export const SET_USER_PREFERENCES = "SET_USER_PREFERENCES";
